import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', e => {

    const specialOffers = document.querySelectorAll('.catalog-special-offers');
    if (specialOffers) {
        specialOffers.forEach(block => {
            const pagination = block.querySelector('.swiper-pagination');
            const list = block.querySelector('.catalog-special-offers__list');
            // const next = block.querySelector('.catalog-special-offers__next') || null;
            // const prev = block.querySelector('.catalog-special-offers__prev') || null;
            // console.info(list, next, prev);
            const swiper = new Swiper(list, {
                loop: true,
                speed: 1000,
                loopPreventsSliding: true,
                autoplay: {
                    delay: 7500,
                    disableOnInteraction: false,
                },
                navigation: {
                    // nextEl: next,
                    // prevEl: prev,
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: pagination, // Selector for the pagination container
                    clickable: true,       // Makes pagination bullets clickable
                    // ... other pagination options like type, renderBullet, dynamicBullets, etc.
                },
                on: {
                    init() {
                        this.el.addEventListener('mouseenter', () => {
                            this.autoplay.stop();
                        });

                        this.el.addEventListener('mouseleave', () => {
                            this.autoplay.start();
                        });
                    }
                },
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
            });
        });
    }
});
